import * as React from "react";
import FormControl from "@mui/material/FormControl";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { useDispatch } from "react-redux";
import { uploadUserVideos } from "../../../services/videosSlice";
import VideoCardPreview from "../../../components/video/VideoCardPreview";

const categories = [
  {
    value: "UI",
    label: "UI",
  },
  {
    value: "Concept",
    label: "Concept",
  },
  {
    value: "Prototype",
    label: "Prototype",
  },
  {
    value: "AI",
    label: "AI",
  },
  {
    value: "Robotics",
    label: "Robotics",
  },
  {
    value: "Engineering",
    label: "Engineering",
  },
];

const VideoUploadForm = ({ currentUser, editModeData }) => {
  // const { currentUser } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [errors, setErrors] = React.useState({
    categoryError: false,
    videoUrlError: "",
  });
  const dateTime = new Date();
  // const videolink = editModeData !== undefined ? editModeData.videourl : "";
  const [values, setValues] = React.useState({
    in_draft: false,
    in_review: true,
    is_approved: false,
    profileurl: currentUser.photoURL,
    rejected: false,
    rejected_reason: "",
    review_status: "waiting for review",
    timestamp: `${dateTime.getDate()} ${dateTime.getMonth()} ${dateTime.getFullYear()}`,
    user_id: currentUser.uid,
    username: currentUser.displayName,
    videourl: editModeData !== undefined ? editModeData.videourl : "",
    view_count: "",
    category: editModeData !== undefined ? editModeData.category : "",
  });
  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };
  const validateInput = () => {
    if (!values.videourl.startsWith("https://www.youtube.com/embed/")) {
      setErrors({
        categoryError: "",
        videoUrlError: "Invalid Youtube Link",
      });
      setOpen(true);
      return false;
    }
    if (values.category === "") {
      setErrors({
        categoryError: "Please Selecet your video category",
        videoUrlError: "",
      });
      setOpen(true);
      return false;
    }
    return true;
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateInput()) {
      dispatch(uploadUserVideos(values));
    }
  };
  const action = (
    <>
      <Button color="secondary" size="small" onClick={handleClose}>
        Close
      </Button>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </>
  );
  return (
    <Box>
      <div className="mt-5">
        <Typography className="m-5" component="h3">Preview</Typography>
        <Typography component="div">
          <VideoCardPreview
            username={editModeData !== undefined ? editModeData.username : values.username}
            profileurl={editModeData !== undefined ? editModeData.profileurl : values.profileurl}
            videourl={editModeData !== undefined ? editModeData.videourl : values.videourl}
          />
        </Typography>
      </div>
      <div>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
          message={`${errors.categoryError} ${errors.videoUrlError}`}
          action={action}
          color="warning"
        />
        <FormControl fullWidth sx={{ m: 1 }}>
          <InputLabel htmlFor="outlined-adornment-videourl">Video Url</InputLabel>
          <OutlinedInput
            id="outlined-adornment-videourl"
            value={values.videourl}
            onChange={handleChange("videourl")}
            startAdornment={<InputAdornment position="start">URL</InputAdornment>}
            label="Video Url"
          />
        </FormControl>
        <TextField
          sx={{ m: 1 }}
          id="outlined-select-category"
          select
          label="Select Video Category"
          value={values.category}
          onChange={handleChange("category")}
          fullWidth
        >
          {categories.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        {!editModeData && <Button onClick={handleSubmit}>Submit</Button>}
      </div>
    </Box>
  );
};

export default VideoUploadForm;
